"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reader_1 = __importDefault(require("./reader"));
exports.BufferReader = reader_1.default;
var writer_1 = __importDefault(require("./writer"));
exports.BufferWriter = writer_1.default;
